import { render } from "./process-list.vue?vue&type=template&id=2bc01f32&scoped=true&ts=true"
import script from "./process-list.vue?vue&type=script&lang=ts"
export * from "./process-list.vue?vue&type=script&lang=ts"

import "./process-list.vue?vue&type=style&index=0&id=2bc01f32&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc01f32"]])

export default __exports__